import { Spinner } from '@/components/Spinner';
import { useStaticDataTypeDetail } from './hooks/useStaticDataTypeDetail';
import { ManageStaticDataTypeView } from './ManageStaticDataTypeView';

export const ManageStaticDataTypeContainer = ({ staticDataTypeId }: { staticDataTypeId?: string }) => {
  const { staticData, isLoading } = useStaticDataTypeDetail(staticDataTypeId);
  if (isLoading) return <Spinner />;
  return <ManageStaticDataTypeView staticDataTypeId={staticDataTypeId} staticData={staticData} />;
};
